import axios from 'axios'
import { handleError } from './error.service'

const apiUrl = window.env.API_URL + '/signatures'

export async function get(token) {
    const requestOptions = {
        headers: {
            'X-Token': `${token}`,

        },
    }
    try {
        const response = await axios.get(`${apiUrl}`, requestOptions)
        return response
    } catch (error) {
        return handleError(error)
    }
}

export async function sendCode(id, channel, token) {
    const requestOptions = {
        headers: {
            'X-Token': `${token}`,
        },
        params: {
            channel: `${channel}`,
        }
    }
    try {
        const response = await axios.get(`${apiUrl}/${id}/code`, requestOptions)
        return response
    } catch (error) {
        return handleError(error)
    }
}

export async function applyCode(id, code, urlCallback, token) {
    const data = (urlCallback) ? { code: `${code}`, urlCallback: `${urlCallback}` } : { code: `${code}` }
    const headers = { 'X-Token': `${token}` }
    const response = await axios.post(`${apiUrl}/${id}/code`, data, { headers: headers })
    return response
}
